import React, { useState } from 'react';
import { Menu, MenuItem, Box, Typography, Avatar} from '@mui/material'
import {Auth} from 'aws-amplify'
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types'
import ClickBox from '../ClickBox';
import { fonts } from '../../util/Theme';

/**
 * Drop down used to represent the different options for a user (profile, logout, etc)
 * @component 
 * @category Headers and Footers 
 * @subcategory NavBar
 */
function Options(props) {
    const navigate = useNavigate()
    const [openDropDown, setOpenDropDown] = useState(false)
    const [anchoredElement, setAnchoredElement] = useState(false)

    const handleClick = (event) =>{
        event.preventDefault()
        setOpenDropDown(true)
        setAnchoredElement(event.target)
    }

    const handleProfile = () =>{
        navigate('/home/profile')
    }
    const handleLogOut = async () =>{
        try{
            await Auth.signOut()
            navigate('/home')
            window.location.reload(false)
            
        }catch(exception){
            console.error(exception)
        }
    }
    return (
        <div>
            <Box sx={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
            <ClickBox onClick={handleClick} sx={{display:'flex'}} showClickable={false}>
                <Avatar sx={{ justifyContent:'center', alignItems:'center',
                    bgcolor: props.selected || openDropDown ? props.hoverColor : 'coral', '&:hover':{bgcolor:props.hoverColor}}} src={props.profile.profile_picture}>
                    {!props.profile.profile_picture? `${props.profile.first_name[0]}${props.profile.last_name[0]}` : <></>}
                </Avatar>
            </ClickBox>
            </Box>
            <Menu open={openDropDown} anchorEl={anchoredElement} onClose={(event)=>setOpenDropDown(false)}>
                <MenuItem onClick={handleProfile}>
                    <Typography fontSize={fonts.menuSize}>Profile</Typography>
                </MenuItem>
                <MenuItem onClick={handleLogOut}>
                    <Typography fontSize={fonts.menuSize}>Logout</Typography>
                </MenuItem>
            </Menu>
        </div>
    );
}

Options.propTypes ={
    /**
     * whether or not the options have been clicked on
     */
    selected: PropTypes.bool,
    /**
     * color for options to turn when hovered over / clicked 
     */
    hoverColor: PropTypes.string,
    /**
     * object representing the Resoure logged in (object that follows same schema as resource in db)
     */
    profile: PropTypes.object
    //profilePicture: PropTypes.string
}

Options.defaultProps = {
    selected: false,
    hoverColor:'secondary.main'
}

export default Options;